// extracted by mini-css-extract-plugin
module.exports = {"refinement":"_2WeosbA","input":"Fz4yZ_w","label":"_1ikeRVG"};